import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import GridColumnInspectorHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper';
import WmsExternalIdsSimpleText, {
    WmsExternalIdsSimpleTextData,
    WmsExternalIdsSimpleTextDataKeys,
    WmsExternalIdsSimpleTextDisplayOptions,
} from '../../../../components/wms-external-ids-simple-text/WmsExternalIdsSimpleText';

const WmsExternalIdsColumnTemplate = (props: CellTemplateProps) => {
    return (
        <React.Fragment>
            <GridColumnInspectorHelper cellProps={props}>
                {(inspectorId, disableInspectorForm) => (
                    <WmsExternalIdsSimpleText
                        disableInspectorForm={disableInspectorForm}
                        inspectorId={inspectorId}
                        data={props.data}
                        defaultProps={WmsExternalIdsColumnTemplateDefaultProps}
                    />
                )}
            </GridColumnInspectorHelper>
        </React.Fragment>
    );
};

export const WmsExternalIdsColumnTemplateDefaultProps =
    {} as WmsExternalIdsSimpleTextDisplayOptions;

export const WmsExternalIdsColumnTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current,
    };
};

export type WmsExternalIdsColumnTemplateData = WmsExternalIdsSimpleTextData & {};

export const WmsExternalIdsColumnTemplateDataKeys = [...WmsExternalIdsSimpleTextDataKeys];

export default WmsExternalIdsColumnTemplate;
